import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { restrictedTimingKeys } from '../constants';
import { logger } from '../logger';
import { visibilityChangeObserver } from '../observer/visibility-change-observer';
import { UntilExperience } from './until-experience';
export var MetricState = /*#__PURE__*/function (MetricState) {
  MetricState["NOT_STARTED"] = "not-started";
  MetricState["STARTED"] = "started";
  MetricState["FINISHED"] = "finished";
  MetricState["CANCELLED"] = "cancelled";
  return MetricState;
}({});
export var PageVisibleState = /*#__PURE__*/function (PageVisibleState) {
  PageVisibleState["VISIBLE"] = "visible";
  PageVisibleState["MIXED"] = "mixed";
  PageVisibleState["HIDDEN"] = "hidden";
  return PageVisibleState;
}({});
function getPageVisibleState() {
  return typeof document !== 'undefined' && document.visibilityState === 'visible' ? PageVisibleState.VISIBLE : PageVisibleState.HIDDEN;
}
export var BaseMetric = /*#__PURE__*/function () {
  function BaseMetric(config) {
    var _this = this,
      _this$config$timings;
    _classCallCheck(this, BaseMetric);
    _defineProperty(this, "state", MetricState.NOT_STARTED);
    _defineProperty(this, "startTime", null);
    _defineProperty(this, "stopTime", null);
    _defineProperty(this, "marks", {});
    _defineProperty(this, "onStopCallbacks", []);
    _defineProperty(this, "custom", null);
    _defineProperty(this, "submetrics", []);
    _defineProperty(this, "route", null);
    _defineProperty(this, "untilOnStopCallback", null);
    _defineProperty(this, "pageVisibleState", getPageVisibleState());
    _defineProperty(this, "setPageVisibleStateToMixed", function () {
      _this.pageVisibleState = PageVisibleState.MIXED;
    });
    this.config = config;
    this.key = config.key.replace(/ /gi, '-');
    this.type = config.type;
    (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function (entry) {
      if (restrictedTimingKeys.includes(entry.key)) {
        // eslint-disable-next-line no-console
        console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
        entry.key = "custom__".concat(entry.key);
      }
    });
  }
  _createClass(BaseMetric, [{
    key: "untilMetrics",
    get: function get() {
      var until = this.config.until;
      if (!until) {
        return [];
      } else if (Array.isArray(until)) {
        return this.getConfiguredUntilMetricArray(until);
      }
      return this.getConfiguredUntilMetricArray([until]);
    }
  }, {
    key: "start",
    value: function start() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$startTime = _ref.startTime,
        startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
      this.clear();
      logger.logCond(!!this.config.debug, this.key, startTime);
      this.state = MetricState.STARTED;
      this.startTime = startTime;
      this.pageVisibleState = getPageVisibleState();
      visibilityChangeObserver.subscribe(this.setPageVisibleStateToMixed);
      this.watchUntil();
    }
  }, {
    key: "stop",
    value: function stop() {
      var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _stopArguments$stopTi = stopArguments.stopTime,
        stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
      if (this.state !== MetricState.STARTED || this.startTime === null) {
        logger.log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
        return false;
      }
      if (stopTime < this.startTime) {
        logger.log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
        return false;
      }
      this.stopTime = stopTime;
      this.state = MetricState.FINISHED;
      this.handleStop(stopArguments);
      visibilityChangeObserver.unsubscribe(this.setPageVisibleStateToMixed);
      return true;
    }
  }, {
    key: "handleStop",
    value: function handleStop(stopArguments) {
      var _this2 = this;
      var _stopArguments$custom = stopArguments.customData,
        customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
      if (customData) {
        this.custom = _objectSpread(_objectSpread({}, this.custom), customData);
      }
      this.config.include && this.config.include.forEach(function (metric) {
        var included = metric.getData();
        if (included.state === MetricState.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) {
          _this2.addSubMetric(metric.getData());
        }
      });
      this.onStopCallbacks.forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
          success = _ref3[0];
        success(stopArguments);
      });
      this.onStopCallbacks = [];
      logger.logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
  }, {
    key: "mark",
    value: function mark(_mark) {
      var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
      this.marks[_mark] = timestamp;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.state !== MetricState.STARTED) {
        return;
      }
      this.state = MetricState.CANCELLED;
      this.cancelUntil();
      this.onStopCallbacks.forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          cancel = _ref5[1];
        cancel();
      });
      this.onStopCallbacks = [];
      visibilityChangeObserver.unsubscribe(this.setPageVisibleStateToMixed);
    }
  }, {
    key: "merge",
    value: function merge(mergeData) {
      this.state = mergeData.state;
      this.pageVisibleState = mergeData.pageVisibleState;
      this.startTime = mergeData.start;
      this.stopTime = mergeData.stop;
      this.marks = _objectSpread(_objectSpread({}, this.marks), mergeData.marks);
      this.submetrics = [].concat(_toConsumableArray(this.submetrics), _toConsumableArray(mergeData.submetrics));
      this.onStopCallbacks = [].concat(_toConsumableArray(this.onStopCallbacks), _toConsumableArray(mergeData.onStopCallbacks));
    }
  }, {
    key: "onStop",
    value: function onStop(success, cancel) {
      this.onStopCallbacks.push([success, cancel]);
    }
  }, {
    key: "removeOnStopCallback",
    value: function removeOnStopCallback(success) {
      var index = this.onStopCallbacks.findIndex(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          successCallback = _ref7[0];
        return success === successCallback;
      });
      if (index > -1) {
        this.onStopCallbacks.splice(index, 1);
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      return {
        key: this.key,
        state: this.state,
        start: this.startTime,
        stop: this.stopTime,
        //todo ranges
        // ranges: this.makeRanges()
        marks: this.marks,
        // todo make copy
        custom: this.custom,
        submetrics: this.submetrics,
        config: this.config,
        route: this.route,
        pageVisibleState: this.pageVisibleState,
        type: this.config.type
      };
    }
  }, {
    key: "getDataToMerge",
    value: function getDataToMerge() {
      return _objectSpread(_objectSpread({}, this.getData()), {}, {
        onStopCallbacks: this.onStopCallbacks
      });
    }
  }, {
    key: "addSubMetric",
    value: function addSubMetric(data) {
      this.submetrics.push(data);
    }

    /**
     *
     * @param metric
     * The array of Until metrics can be of two types
     * This function returns an UntilExperience
     */
  }, {
    key: "getConfiguredUntilMetric",
    value: function getConfiguredUntilMetric(metricOrConfig) {
      return metricOrConfig instanceof BaseMetric ? UntilExperience.fromMetric(metricOrConfig) : UntilExperience.fromConfig(metricOrConfig);
    }
  }, {
    key: "getConfiguredUntilMetricArray",
    value: function getConfiguredUntilMetricArray(metricArray) {
      var _this3 = this;
      if (!metricArray.length) {
        return [];
      }
      return metricArray.map(function (metric) {
        return _this3.getConfiguredUntilMetric(metric);
      });
    }
  }, {
    key: "isUntilFinished",
    value: function isUntilFinished() {
      return this.untilMetrics.every(function (metric) {
        return metric.experience.getData().state === MetricState.FINISHED;
      });
    }
  }, {
    key: "handleAllUntilFinished",
    value: function handleAllUntilFinished() {
      // Order by ascending stop time
      var sorted = _toConsumableArray(this.untilMetrics).sort(function (m1, m2) {
        return m1.getDependencyStopTime() - m2.getDependencyStopTime();
      });

      // Find the latest page segment to become fully interactive
      var latestFullyInteractiveSegment = _toConsumableArray(this.untilMetrics).reduce(function (currentLatestSegment, metric) {
        var _currentLatestSegment, _metric$getFullyInter;
        var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
        var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
        return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
      }, undefined);

      // Accumulate the custom data from each metric, later metrics take priority
      var accumulatedCustomData = {};
      sorted.forEach(function (metric) {
        Object.assign(accumulatedCustomData, metric.experience.getData().custom);
      });
      var latestSegment = sorted[sorted.length - 1];
      var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
      this.stop({
        stopTime: latestSegment.getDependencyStopTime(),
        customData: _objectSpread(_objectSpread({}, accumulatedCustomData), {}, {
          segment: latestSegment.getKey(),
          segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
        }, latestFullyInteractiveStopTime ? {
          latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
          latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
        } : {})
      });
    }
  }, {
    key: "watchUntil",
    value: function watchUntil() {
      var _this4 = this;
      if (!this.untilMetrics.length) {
        return;
      }
      if (this.isUntilFinished()) {
        // Already finished, handle it immediately
        this.handleAllUntilFinished();
        return;
      }

      // If not currently finished, register stop callbacks to re-check
      this.untilOnStopCallback = function () {
        if (_this4.isUntilFinished()) {
          _this4.handleAllUntilFinished();
        }
      };
      this.untilMetrics.forEach(function (metric) {
        if (metric.experience.getData().state !== MetricState.FINISHED) {
          metric.experience.onStop(_this4.untilOnStopCallback, function () {
            return _this4.cancel();
          });
        }
      });
    }
  }, {
    key: "cancelUntil",
    value: function cancelUntil() {
      var _this5 = this;
      this.untilMetrics.forEach(function (metric) {
        if (metric.experience.getData().state !== MetricState.CANCELLED && _this5.untilOnStopCallback) {
          metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
      this.cancelUntil();
      this.state = MetricState.NOT_STARTED;
      this.startTime = null;
      this.stopTime = null;
      this.marks = {};
      this.custom = null;
      this.submetrics = [];
      this.route = null;
      this.pageVisibleState = getPageVisibleState();
    }
  }]);
  return BaseMetric;
}();
_defineProperty(BaseMetric, "FMP", 'fmp');